var $be8c72c0f1e8f9cb$exports = require("./useDisclosureState.main.js");
var $8654db152d40114d$exports = require("./useDisclosureGroupState.main.js");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "useDisclosureState", () => $be8c72c0f1e8f9cb$exports.useDisclosureState);
$parcel$export(module.exports, "useDisclosureGroupState", () => $8654db152d40114d$exports.useDisclosureGroupState);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



//# sourceMappingURL=main.js.map
